module.exports = __webpack_public_path__ + "img/banque_nationale.f9d5be9e.png";